<template>
  <div class="home-page">
    <childNav
      :routerName="$t('openConfig.title')"
      :backFlag="false"
      :languageFlag="true"
    ></childNav>
    <div class="main-body">
      <div class="main-card">
        <div
          v-for="(item, index) in functionList"
          :key="index"
          class="card-item"
          @click="toFunction(item)"
        >
          <div class="img-box">
            <img :src="item.funPic" class="card-img" />
          </div>

          <div class="admin-text text-top">
            <i class="el-icon-menu icon-margin"></i>
            <span class="card-title">{{ item.funName }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content_win"></div>
  </div>
</template>

<script>
import childNav from "@/components/homeNav/childNav.vue";
export default {
  name: "message",
  components: {
    childNav,
  },
  data() {
    return {
      functionList: this.global.FunctionList,
    };
  },
  computed: {},
  watch: {},
  created() {
    // 原本缓存语言数据，zh更换成zh_CN（修改了语言标识）
    if (localStorage.getItem("language") === "zh") {
      localStorage.setItem("language", "zh_CN");
    }
    if (localStorage.getItem("language") === "en") {
      localStorage.setItem("language", "en_US");
    }
  },
  mounted() {},
  methods: {
    toFunction(item) {
      this.$router.push(item.path);
    },
  },
};
</script>
